import type { AdditionalQueryParams } from '../../../hooks/usePagination';
import {
  type DateRange,
  readDateRange,
  replaceDateRange,
  replaceParam,
  replaceParams,
  toActiveFilter,
  toArrayFilter,
  toDateFilter,
} from './filterParamUtils';

export type PartnerFilterData = {
  isActive: string;
  fullName: string[];
  email: string[];
  createdAt: DateRange;
  roleTypes: string[];
};

const ARRAY_PARAMS = ['fullName', 'email', 'roleTypes'] as const;

const parse = (params: URLSearchParams): PartnerFilterData => ({
  isActive: params.get('isActive') ?? '',
  fullName: params.getAll('fullName'),
  email: params.getAll('email'),
  createdAt: readDateRange(params),
  roleTypes: params.getAll('roleTypes'),
});

const write = (current: URLSearchParams, data: PartnerFilterData) => {
  const params = new URLSearchParams(current);

  replaceParam(params, 'isActive', data.isActive);
  ARRAY_PARAMS.forEach((key) => replaceParams(params, key, data[key]));
  replaceDateRange(params, data.createdAt);

  return params;
};

const toApiQuery = (data: PartnerFilterData): AdditionalQueryParams => ({
  roleTypes: data.roleTypes,
  filters: {
    isActive: toActiveFilter(data.isActive),
    fullName: toArrayFilter(data.fullName),
    email: toArrayFilter(data.email),
    createdAt: toDateFilter(data.createdAt),
  },
});

export const partnerFilterParams = {
  parse,
  write,
  toApiQuery,
};
